import { useContext } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

// Store
import { useKnowledgeBaseStore } from '~/store'

// Composables
import useAnalytics from '@/composables/analytics/useAnalytics'

export default () => {
  const context = useContext()
  const analytics = useAnalytics()
  const knowledgeBaseStore = useKnowledgeBaseStore()
  const { searchInput } = storeToRefs(knowledgeBaseStore)

  /*
    Track searches in the knowledge base on the technical support pages
  */
  const trackKnowledgebaseArticleClick = (options: {
    type: string
    clickedArticleTitle: string
    clickedArticlePosition: number
  }) => {
    const { type, clickedArticleTitle, clickedArticlePosition } = options

    // Adding 1 on clicked position because it recievs index that starts on 0
    context.$gtm.push({
      event: 'knowledgebase_article_click',
      search_term: searchInput.value,
      search_type: type,
      article_title: clickedArticleTitle,
      article_position: clickedArticlePosition + 1,
      ...analytics.getCustomDimensions().ga4,
    })
  }

  /*
    Track votes on the knowledge base article pages
  */
  const trackKnowledgebaseArticleVote = (options: { articleTitle: string; articleId: string; articleVote: string }) => {
    const { articleTitle, articleId, articleVote } = options

    context.$gtm.push({
      event: 'knowledgebase_article_vote',
      article_title: articleTitle,
      article_id: articleId,
      article_vote: articleVote,
      ...analytics.getCustomDimensions().ga4,
    })
  }

  return {
    trackKnowledgebaseArticleClick,
    trackKnowledgebaseArticleVote,
  }
}
